import { useQuery } from '@tanstack/react-query';
import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { FullScreenLoader } from '../../components/loader';
import { api } from '../../lib/api';
import { useProjectStore } from '../../stores/project-store';

/**
 * Land on the current site's overview — honouring the selected site (single source
 * of truth) and falling back to the first remaining site. With no site the org is
 * in onboarding: the Shell locks the dashboard and shows the add-a-site wizard, so
 * this branch is reached only transiently (e.g. right after the last site is
 * deleted). Never render an empty screen — keep a loader until the Shell takes over.
 */
export function HomeRedirect(): ReactElement {
  const query = useQuery({ queryKey: ['projects'], queryFn: () => api.listProjects() });
  const currentProjectId = useProjectStore((s) => s.currentProjectId);
  if (query.isLoading) return <FullScreenLoader />;
  const projects = query.data?.projects ?? [];
  const target = projects.find((p) => p.id === currentProjectId) ?? projects[0];
  if (target) return <Navigate to={`/projects/${target.id}`} replace />;
  return <FullScreenLoader />;
}
